//import { ref, onMounted, onUnmounted } from 'vue'

export function useScript(){

    function $bodyScript (src) {
        const plugin = document.createElement("script");
        plugin.setAttribute(
            "src",
            src
        );
        plugin.async = true;
        document.head.appendChild(plugin);

    }

    function $headerLink (href) {
        const plugin = document.createElement("link");
        plugin.setAttribute(
            "href",
            href
        );
        plugin.async = true;
        document.head.appendChild(plugin);

    }

    function $delLink (href) {
        let el = document.querySelector("link[href='" + href + "']")
        if(el){
            el.remove()
        }
    }

    function $delScript (src) {
        let el = document.querySelector("script[src='" + src + "']");
        if(el){
            el.remove();
        }
    }

    return {
        $bodyScript,
        $headerLink,
        $delLink,
        $delScript
    }
}



